<template>
  <div>
    <v-progress-linear :active="isActive" indeterminate></v-progress-linear>
    <v-card class="pt-4 mt-2">
      <RangeDate />
    </v-card>

    <Gmt class="ml-4" />
    <v-card fluid class="mt-2">
      <div class="mx-auto pb-6" style="max-width: 1360px">
        <div class="pa-2 mt-2">
          <v-row no-gutters class="align-center">
            <v-col cols="12" md="9" class="d-flex">
              <div class="ml-2 text-center">
                <div class="grey--text overline">{{ $t("bankBalance") }}</div>
                <div>
                  {{ $t("labelCurrency") }}&nbsp;{{
                    historic.saldo > 0 ? historic.saldo : credit | saldo
                  }}
                </div>
              </div>

              <div class="ml-4 text-center">
                <div class="grey--text overline">{{ $t("awardRescue") }}</div>
                <div
                  v-if="local_resgate === 'Nenhum vinculado'"
                  class="grey--text"
                >
                  {{ local_resgate }}
                </div>
                <div v-else>{{ local_resgate }}</div>
              </div>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                :class="$vuetify.breakpoint.smAndDown ? 'mt-3' : ''"
                v-model="search"
                append-icon="mdi-magnify"
                :label="$t('searchLabelBetonline')"
                single-line
                hide-details
                dense
                solo-inverted
                clearable
              ></v-text-field>
            </v-col>
          </v-row>
        </div>

        <v-divider></v-divider>
        <v-data-table
          :headers="headers"
          :items="historic.movimentacoes"
          :search="search"
          :items-per-page="10"
          class="elevation-1 historic-bet"
        >
          <template v-slot:item.date="{ item }">
            <span class="caption">{{ item.date_transition | dataFormat }}</span>
          </template>
        </v-data-table>

        <v-scroll-y-reverse-transition>
          <v-alert
            text
            dense
            type="warning"
            border="left"
            class="my-4"
            v-if="noData"
            >{{ noData }}</v-alert
          >
        </v-scroll-y-reverse-transition>
      </div>
    </v-card>
  </div>
</template>

<script>
import Vue from "vue";
import Gmt from "@/components/gmt/";
import RangeDate from "../../_components/filter/RangeDate/RangeDate.vue";

export default {
  name: "bank",
  components: {
    RangeDate,
    Gmt,
  },
  data: () => {
    return {
      dialog: false,

      isActive: false,

      ranteUi: "",
      historic: [],
      noData: false,
      search: "",
    };
  },
  computed: {
    rangeDate() {
      return this.$store.state.range.date;
    },
    feedBack() {
      return this.$store.state.feedbackProgress;
    },
    local_resgate() {
      const agent = this.$store.state.logged.data.nome_vendedor;
      return agent === null ? "" : agent;
    },
    userInfo() {
      return this.$store.state.user;
    },
    credit() {
      return this.$store.state.cash;
    },
    headers() {
      return [
        { text: this.$t("simpleTableDate"), value: "date_transition" },
        { text: this.$t("simpleTableId"), value: "id" },
        { text: this.$t("simpleTableOperation"), value: "type_operation" },
        { text: this.$t("simpleTableValue"), value: "value" },
      ];
    },
  },
  mounted() {
    this.getData();
  },

  watch: {
    "rangeDate.date_start"() {
      if (this.feedBack) {
        return;
      }
      this.getData();
    },
    "rangeDate.date_final"() {
      if (this.feedBack) {
        return;
      }
      this.getData();
    },
  },
  methods: {
    getData() {
      this.open = true;
      this.$axios
        .post(
          "/player/bank/extract",
          this.$formdata({
            ...this.rangeDate,
          })
        )
        .then((resp) => {
          this.historic = resp.data.dados;
          this.historic.movimentacoes.forEach((item) => {
            item.date_transition = new Date(
              item.date_transition.replace(" ", "T")
            ).toLocaleString();
          });
        })
        .catch((err) => {
          this.historic = [];

          const msg = err.response.data.messages[0];
          const color = "warning";
          this.$store.commit("setNotification", { msg, color });
        });
    },

    // DEFAULT ERRORS
  },
  filters: {
    saldo: function(value) {
      return value == undefined || value == null
        ? "00,00"
        : Number(value).toLocaleString("pt-BR");
    },
    dataFormat: function(datedb) {
      let date = new Date(`${datedb} UTC`);
      let formatDate = Vue.prototype.$date.format(
        date.toISOString().substring(0, 10),
        "DD/MM/YYYY"
      );
      let hour = date.toISOString().substring(11, 19);
      return `${formatDate} ${hour}`;
    },
  },
};
</script>
